var React = require('react');

function CheckboxIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#5998F8","key":0}),React.createElement("path",{"d":"M9.30047 16.5C9.69047 16.89 10.3205 16.89 10.7105 16.5L18.2905 8.91002C18.6805 8.52002 18.6805 7.89002 18.2905 7.50002C17.9005 7.11002 17.2705 7.11002 16.8805 7.50002L10.0005 14.38L7.12047 11.5C6.73047 11.11 6.10047 11.11 5.71047 11.5C5.32047 11.89 5.32047 12.52 5.71047 12.91L9.30047 16.5Z","fill":"white","key":1})]);
}

CheckboxIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckboxIcon;

CheckboxIcon.default = CheckboxIcon;
